export default {
  'mobileapp-splashscreen-warning-maxversion': '2.3.6',
  'mobileapp-branded-splashscreen-warning-maxversion': '1.5.6',
  'banner-blackout-text':
    'You are currently in a blackout period as we are preparing to transfer your account. As a result, all online functionality has been suspended. We apologize for any inconvenience.',
  'mobileapp-splashscreen-warning-minversion': '2.3.0',
  'mobileapp-branded-splashscreen-warning-minversion': '1.5.0',
  'register-step-3-credentials-password-rules-1':
    'Must be between 15-256 characters in length',
  'register-step-3-credentials-password-rules-3':
    'Must include at least one of these symbols ^ $ * . [ ] { } ( ) ? - \\ " ! @ # % & / \\ , > < \' ; | _ ~ `',
  'register-step-3-credentials-password-rules-5':
    'Must contain at least one upper and lowercase letter',
  'register-step-3-credentials-username-rules-3':
    'Can only include these symbols ^ $ * . [ ] { } ( ) ? - \\ " ! @ # % & / \\ , > < \' ; | _ ~ `',
  'hqy-sso-banner-text':
    'You have an account which is now being administered on the HealthEquity platform.',
  'migrated-banner-text':
    'As part of your upcoming account transfer, an account has been opened on your behalf on the HealthEquity platform.',
  'blackout-banner-text':
    'You are currently in a blackout period as we are preparing to transfer your account. As a result, all online functionality has been suspended. We apologize for any inconvenience.',
  'menu-new-site': 'Link to New Site',
  'global_migrated-member-error':
    'Your account has been transferred to HealthEquity and any updates to your account must be made at my.healthequity.com',
  'mobileapp-migrated-member-error':
    'Your account has been transferred to HealthEquity and any updates to your account must be made at my.healthequity.com',
  'mobileapp-banner-app-link': 'Get HealthEquity App',
  'register_form-error_confirm-password_same-as': 'Passwords do not match',
  'account-hsainfo_page-header-subtitle': 'Interest Rates and Terms',
  'account-hsainfo_page-header-title': 'HSA Type Information',
  'Enrollment-footer_link_privacy-policy': 'Privacy Policy',
  'footer_link_privacy-policy': 'Privacy Policy',
  'activate-hsa_form-label_terms-and-conditions':
    'I have read and agree to the terms and conditions linked above. ',
  'activate-hsa_terms-and-conditions-action-statement':
    'Please review and agree to the terms and conditions linked below for activating your Health Savings Account.',
  'remove-ari_page-description':
    'This person will no longer be able to contact customer service on your behalf. This action has no affect on whether you can use your account to pay for medical expenses related to this person.',
  'account-settings_title_hsa-plan': 'HSA Type',
  'submit-app_form-label_terms-and-conditions':
    'I have read and agree to the terms and conditions linked above. ',
  'account-settings_action_change-hsa': 'Change type',
  'global_terms-and-conditions-action-statement':
    'Please review and agree to the terms and conditions linked below for opening a Health Savings Account.',
  'account-hsainfo_page-title': 'Your HSA: %hsaType%',
  'account-overview_label_your-hsa-type': 'Your HSA',
  'account-hsainfo_action_back': 'Back to my account',
  'account-hsainfo_sidebar-title': 'Terms',
  'account-hsainfo_label_interest-effective-date':
    'Interest rates effective as of June 1, 2020.',
  'account-hsainfo_page-description':
    'You will earn monthly interest based on the average daily base balance in your account for that month. Base balance does not include any invested HSA funds.',
  'account-overview_action_view-hsa-info': 'View information',
  'investment-transfer_form-label_linked-terms-agreement':
    'I have read and agree to the linked terms and conditions.',
  'account-settings_link_hsa-type-info': 'View information',
  'pdf-statement-contributions-current-tax-year':
    'Current Tax Year Contributions',
  'xls-statement-overview-label-contributions-current':
    'Current Tax Year Contributions',
  'statements_label_contributions-prior-tax-year':
    'Prior Tax Year Contributions',
  'statements_label_contributions-current-tax-year':
    'Current Tax Year Contributions',
  'xls-statement-overview-label-contributions-prior':
    'Prior Tax Year Contributions',
  'pdf-statement-contributions-prior-tax-year': 'Prior Tax Year Contributions',
  'submit-claim_action_missing-patient-name-proceed': 'Continue',
  'submit-claim_action_missing-patient-name-back': 'Go Back',
  'submit-claim_text_missing-patient-name':
    "Not including the Patient Name might impact the provider's ability to process the payment. Are you sure you want to continue?",
  'submit-claim_title_missing-patient-name': 'Patient Name is Missing',
  'login_page-title': 'Member Sign-In',
  'register-page-help-phone-capital-bluecross': '(877) 293-7041',
  'account-tax-forms_body_5048-description':
    'Tax document Form 5498-SA includes information regarding contributions made for a specific tax year. Since contributions can be made to an HSA up to the tax filing deadline, the 5498-SA is generated the month following the deadline as an informational form. You can use this document to make sure the information matches your tax filing.',
  'add-debit-card_form-label_terms-and-conditions':
    'I certify that such expenses will not be eligible for benefit payment by any other insurance carrier and that such expenses will not be manually submitted by me to this or any other reimbursement account when I use my debit card. I understand that any debit card transaction using funds other than HSA may be subject to proof of purchase documentation upon request for claim processing. Failure to respond will result in cancellation of the debit card and I must reimburse the plan with after-tax dollars.',
  'add-debit-card_form-label_terms-and-conditions-crossover':
    'I certify that such expenses will not be eligible for benefit payment by any other insurance carrier and that such expenses will not be manually submitted by me to this or any other reimbursement account when I use my debit card. I understand that any debit card transaction using funds other than HSA may be subject to proof of purchase documentation upon request for claim processing. Failure to respond will result in cancellation of the debit card and I must reimburse the plan with after-tax dollars.',
  'add-self-debit-card_form-label_terms-and-conditions':
    'I certify that such expenses will not be eligible for benefit payment by any other insurance carrier and that such expenses will not be manually submitted by me to this or any other reimbursement account when I use my debit card. I understand that any debit card transaction using funds other than HSA may be subject to proof of purchase documentation upon request for claim processing. Failure to respond will result in cancellation of the debit card and I must reimburse the plan with after-tax dollars.',
  'add-dependent-debit-card_form-label_terms-and-conditions':
    'I certify that such expenses will not be eligible for benefit payment by any other insurance carrier and that such expenses will not be manually submitted by me to this or any other reimbursement account when I use my debit card. I understand that any debit card transaction using funds other than HSA may be subject to proof of purchase documentation upon request for claim processing. Failure to respond will result in cancellation of the debit card and I must reimburse the plan with after-tax dollars.',
  'add-self-debit-card_form-label_terms-and-conditions-crossover':
    'I certify that such expenses will not be eligible for benefit payment by any other insurance carrier and that such expenses will not be manually submitted by me to this or any other reimbursement account when I use my debit card. I understand that any debit card transaction using funds other than HSA may be subject to proof of purchase documentation upon request for claim processing. Failure to respond will result in cancellation of the debit card and I must reimburse the plan with after-tax dollars.',
  'add-dependent-debit-card_form-label_terms-and-conditions-crossover':
    'I certify that such expenses will not be eligible for benefit payment by any other insurance carrier and that such expenses will not be manually submitted by me to this or any other reimbursement account when I use my debit card. I understand that any debit card transaction using funds other than HSA may be subject to proof of purchase documentation upon request for claim processing. Failure to respond will result in cancellation of the debit card and I must reimburse the plan with after-tax dollars.',
  'xls-statement-overview-label-beginning-balance':
    'Beginning Balance as of %startDate%',
  'xls-statement-overview-label-accumulation-amount': 'Accumulation Amount',
  'xls-statement-overview-value-months-from-claim': 'months from date of claim',
  'xls-statement-overview-label-threshold': 'Threshold',
  'xls-statement-overview-label-claims-filing-deadline':
    'Claims filing deadline',
  'xls-statement-overview-label-grace-period-end-date': 'Grace Period End Date',
  'xls-statement-overview-label-plan-type': 'Plan Type',
  'xls-statement-overview-label-termination-date': 'Termination Date',
  'xls-statement-overview-sheet-name': 'Overview-%accountDescription%',
  'xls-statement-overview-label-start-date': 'Start date',
  'xls-statement-overview-label-end-date': 'End date',
  'xls-statement-overview-label-rollover-from-prior-year':
    'Rollover from Prior Year',
  'xls-statement-overview-label-election-amount': 'Election Amount',
  'xls-statement-overview-label-employer-funding': 'Employer Funding',
  'xls-statement-overview-label-contributions': 'Contributions',
  'xls-statement-overview-label-withdrawals': 'Withdrawals',
  'xls-statement-overview-label-fees': 'Fees',
  'xls-statement-overview-label-interest-earned': 'Interest Earned',
  'xls-statement-overview-label-other-transfers': 'Other Transfers',
  'xls-statement-overview-label-investment-transfers':
    'Investment Account Transfers',
  'xls-statement-overview-label-available-balance': 'Available Balance',
  'xls-statement-details-sheet-name': 'Details',
  'xls-statement-details-category-accumulation': 'Accumulation',
  'xls-statement-details-header-category': 'Category',
  'xls-statement-details-header-tax-year': 'Tax Year',
  'xls-statement-details-header-description': 'Description',
  'xls-statement-details-header-posted-date': 'Posted Date',
  'xls-statement-details-header-amount': 'Amount',
  'xls-statement-details-category-transfer': 'Transfer',
  'xls-statement-details-category-interest': 'Interest',
  'xls-statement-details-category-fee': 'Fee Withdrawal',
  'xls-statement-details-category-contribution': 'Contribution',
  'xls-statement-details-category-investment-transfer': 'Investment Transfer',
  'xls-transactions-sheet-name': 'Activity-%accountDescription%',
  'xls-statement-details-category-claim': 'Claim',
  'xls-transactions-header-posted-date': 'Posted Date',
  'xls-transactions-header-type': 'Type',
  'xls-transactions-header-amount': 'Amount',
  'xls-transactions-header-description': 'Description',
  'xls-transactions-header-action-required': 'Action Required',
  'xls-transactions-header-service-from': 'Service From',
  'xls-transactions-header-service-to': 'Service To',
  'xls-transactions-header-has-attachment': 'Has Attachment',
  'pdf-eop-appeal-rights-description':
    'If you have questions on how your claim was processed please review our important claims processing information and your complaint/appeal filing rights.',
  'pdf-eop-amount-approved': 'Approved',
  'pdf-eop-appeal-rights': 'Appeal Rights',
  'pdf-eop-account': 'Account',
  'pdf-eop-amount-submitted': 'Submitted',
  'xls-transactions-header-note': 'Note',
  'pdf-eop-claim-summary': 'Claim Summary',
  'pdf-eop-claims': 'Individual Claims',
  'pdf-eop-claim-number': 'Claim #',
  'pdf-eop-explanation-of-payment': 'Explanation of Payment',
  'pdf-eop-denial-adjustment-reason': 'Reason',
  'pdf-eop-not-applicable': 'N/A',
  'pdf-eop-payee': 'Payee',
  'pdf-eop-patient': 'Patient',
  'pdf-eop-service-to-date': 'Service To',
  'pdf-eop-payment-issue-date': 'Payment Issue Date',
  'pdf-eop-payment-type': 'Payment Type',
  'pdf-eop-service-from-date': 'Service From',
  'pdf-eop-service-type': 'Service Type',
  'pdf-general-account': 'Account:',
  'pdf-eop-total-paid': 'Total Paid',
  'pdf-eop-source': 'Source',
  'pdf-general-available-balance': 'Available Balance:',
  'pdf-eop-summary': 'Payment Summary',
  'pdf-general-amount': 'Amount',
  'pdf-general-participant': 'Participant:',
  'pdf-general-posted': 'Posted',
  'pdf-general-tax-year': 'Tax Year',
  'pdf-statement-range-message':
    'This account summary is being provided to reflect all account activity processed on your account from %startDate% through %endDate%. ',
  'pdf-general-transaction': 'Transaction',
  'pdf-statement-title': 'Member Account Statement',
  'pdf-statement-thank-you-message':
    'Thank you for being a valued customer of %groupBrandName%. ',
  'pdf-statement-tax-year-message':
    'This account summary is being provided to reflect all account activity processed on your account during the %taxYear% tax year. ',
  'pdf-statement-visit-our-website-message':
    'Please visit our website at %groupMainSiteURL% for detailed account activity throughout the year, including available balance, payments and claim information.',
  'pdf-statement-claims-no-grace':
    'Claims must be incurred during the plan year in order to be considered for payment from your account.',
  'pdf-statement-date': 'Date:',
  'pdf-statement-employer': 'Employer:',
  'pdf-statement-please-note': 'Please note the following:',
  'pdf-statement-sa-id': 'SA ID:',
  'pdf-statement-claims-grace-period':
    'Claims must be incurred during the plan year or the grace period in order to be considered for payment from your account.',
  'pdf-statement-investment-message':
    'This summary does not include your investment account balance. Visit our website for investment account information.',
  'pdf-statement-hra-or-fsa-note':
    'If there is a termination date on your account, expenses must be incurred prior to the termination date to be eligible for reimbursement. Please see your summary plan description for more information. Claims must be received on or by the claims filing deadline to be eligible for reimbursement.',
  'pdf-statement-cannot-open-investment-account':
    'As soon as your Base Balance is over $%threshold% you qualify for an investment account. For more information, please visit our website.',
  'pdf-statement-can-open-investment-account':
    'Your Base Balance is over $%threshold% - you now qualify for an investment account. To open an investment account, or for more information, please visit our website.',
  'pdf-statement-account-start-date': 'Account Start Date',
  'pdf-statement-product-summary': '%product% Summary',
  'pdf-statement-account-effective-date': 'Account Effective Date',
  'pdf-statement-election-amount': 'Election Amount',
  'pdf-statement-account-end-date': 'Account End Date',
  'pdf-statement-rollover-prior-year': 'Rollover from Prior Year',
  'pdf-statement-beginning-balance': 'Beginning Balance',
  'pdf-statement-employer-funding': 'Employer Funding',
  'pdf-statement-grace-period-end': 'Grace Period End Date',
  'pdf-statement-claims-filing-deadline': 'Claims Filing Deadline',
  'pdf-statement-contributions': 'Contributions',
  'pdf-statement-investment-account-transfers': 'Investment Account Transfers',
  'pdf-statement-other-transfers': 'Other Transfers',
  'pdf-statement-interest-earned': 'Interest Earned',
  'pdf-transactions-no-transactions-found': 'No transactions.',
  'pdf-statement-fees': 'Fees',
  'pdf-statement-account-termination-date': 'Account Termination Date',
  'pdf-statement-available-base-balance': 'Available Base Balance',
  'pdf-footer-visit-website': 'Visit our website to:',
  'pdf-statement-withdrawals': 'Withdrawals',
  'pdf-statement-threshold-amount': 'Threshold Amount',
  'pdf-statement-accumulation-amount': 'Accumulation Amount',
  'pdf-transactions-date': 'Date',
  'pdf-footer-visit-website-view-transactions':
    'View all transactions associated with your account.',
  'pdf-footer-visit-website-maximize-benefits':
    'Maximize account benefits by easily and conveniently submitting your claims online.',
  'pdf-footer-visit-website-setup-direct-deposit':
    'Set up direct deposit for faster claim reimbursements.',
  'pdf-transactions-description': 'Description',
  'pdf-transactions-header':
    'The following claims were processed against your account during this reporting period:',
  'pdf-footer-notify-if-not-correct':
    'We are committed to maintaining complete and accurate information about you and your accounts. If you believe the information appearing on this statement is not correct, please notify us at:',
  'pdf-transaction-detail-claim-number': 'Claim Number',
  'pdf-transactions-posted-transactions': 'Posted Transactions',
  'pdf-transactions-transactions': 'All Transactions',
  'pdf-transaction-detail-service-date': 'Service Date',
  'pdf-transactions-type': 'Type',
  'pdf-transaction-detail-denied-amount': 'Denied Amount',
  'pdf-transaction-detail-process-date': 'Process Date',
  'pdf-transaction-detail-paid-amount': 'Paid Amount',
  'pdf-transaction-detail-service-dates': 'Service Dates',
  'pdf-transaction-detail-denial-reason': 'Denial Reason',
  'pdf-transaction-detail-claim-details': 'Claim Details',
  'footer-vermont-licensee':
    'Blue Cross and Blue Shield of Vermont is an Independent Licensee of the Blue Cross and Blue Shield Association.',
  'mobileapp-error-failed-signin':
    "We're unable to sign you in. Please make sure your username and password are correct and try again or contact customer service at (800) 859-2144 for assistance.",
  'mobileapp-error-entersekt-user-reregister-message':
    'This version of the app is using a new authentication system. You will need to sign in again to move your account.',
  'mobileapp-error-failed-locked':
    'Your access has been locked due to too many failed login attempts. Please try again later or contact Customer Support at 1-800-859-2144 for assistance.',
  'footer-vermont-translate-french':
    "Por obtenir des services d'assistance linguistique gratuits, appelez le (800) 247-2583.",
  'footer-vermont-translate-spanish':
    'Para servicios gratuitos de asistencia con el idioma, llame al (800) 247-2583.',
  'footer-vermont-translate-english':
    'For free language-assistance services, call (800) 247-2583.',
  'make-deposit_form-label_terms-and-conditions':
    'I understand it is my responsibility (1) to determine whether I am eligible to make contributions to my HSA and (2) to determine whether contributions to my HSA have exceeded the applicable maximum annual contribution limit. Deposits may not be available for immediate withdrawal until confirmed by my bank.',
  'global_log-in': 'Sign in',
  'register-page-subtitle': 'Easily access your account information online.',
  'register-step-1-title': 'Enter Your Spending Account ID',
  'register-page-header-already-registered': 'Already Registered? Sign In',
  'register-page-title': 'Online Registration',
  'register-step-1-label': 'Enter SA ID',
  'register-step-1-subtitle':
    'To register for online access, we need to know your Spending Account ID number.',
  'register-step-1-SAID-label': 'Spending Account ID',
  'register-step-1-info-widget-paragraph-2':
    'If your Account Verification Form is lost or was never received, please call customer service to assist you in registering your account: %brandPhone%',
  'register-step-1-info-widget-paragraph-1':
    'Your Spending Account ID (SA ID) is the number on your Account Verification Form, which was mailed to you shortly after your account was opened.',
  'register-step-1-SAID-error-required':
    'Enter your Spending Account ID (SA ID)',
  'register-step-1-info-widget-header': 'What is my Spending Account ID?',
  'register-step-2-label': 'Confirm Identity',
  'register-step-1-next-button-text': 'Next',
  'register-step-2-title': 'Confirm your Identity',
  'register-step-2-subtitle':
    'Please confirm your identity by providing the requested information below.',
  'register-step-2-DOB-error-future-date': 'Date of birth must be a past date',
  'register-step-2-DOB-invalid-date': 'Invalid date',
  'register-step-2-DOB-hint': 'MM/DD/YYYY',
  'register-step-2-DOB-label': 'Date of birth',
  'register-step-2-DOB-error-required': 'Enter your date of birth',
  'register-step-2-SSN-label': 'Last 4 digits of SSN',
  'register-step-2-error-text':
    'Unable to confirm the information entered. Please try again.',
  'register-step-2-SSN-error': 'Enter the last 4 digits of your SSN',
  'register-step-2-captcha-text':
    'This form is protected by reCAPTCHA and the Google [Privacy Policy](https://policies.google.com/privacy) and [Terms of Service](https://policies.google.com/terms) apply.',
  'register-step-2-next-button-text': 'Next',
  'register-step-2-back-button-text': 'Back',
  'register-step-2-submitting-text': 'Verifying Identity..',
  'register-step-3-label': 'Create Profile',
  'register-step-3-email-submitting-text': 'Updating Email..',
  'register-step-3-email-title': 'Add Email',
  'register-step-3-email-subtitle':
    "We don't have an email address for you on file. Please add an email address so that you can receive important account notifications and updates.",
  'register-step-3-email-label': 'Email',
  'register-step-3-email-error-invalid': 'Invalid email address format',
  'register-step-3-email-error-length':
    'Email cannot be longer than %maxLength% characters.',
  'register-step-3-email-next-button-text': 'Next',
  'register-step-3-email-error-required': 'Enter your email address',
  'register-step-3-credentials-username-rules-2':
    'Can be a combination of letters, numbers, or symbols',
  'register-step-3-credentials-title': 'Create Your Online Profile',
  'register-step-3-email-error-text':
    'Unable to process the information at this time. Please try again.',
  'register-step-3-credentials-subtitle':
    'Please create the username and password you will use to sign into your account.',
  'register-step-3-credentials-username-label': 'Username',
  'register-step-3-credentials-username-rules-header': 'Your username:',
  'register-step-3-credentials-username-rules-1':
    'Must be between 6-14 characters in length',
  'register-step-3-credentials-password-label': 'Password',
  'register-step-3-credentials-password-rules-2':
    'Must begin with a letter or number and contain at least one number',
  'register-step-3-credentials-password-rules-4':
    'Cannot use any letter, symbol or number more than twice in a row',
  'register-step-3-credentials-password-rules-header': 'Your password:',
  'register-step-3-credentials-terms-label':
    "I have read and agree to the <a href='%termsOfUseLink%' target='_blank'>Terms of Use</a> and <a href='%privacyPolicyLink%' target='_blank'>Privacy Policy</a>",
  'register-step-3-credentials-next-button-text': 'Finish',
  'register-step-3-credentials-error-text':
    'Unable to process the information at this time. Please try again.',
  'register-step-3-credentials-error-duplicate-username-text':
    'The username requested is already in use. Please try again.',
  'register-step-3-credentials-error-already-registered-text':
    'We show you are already a registered user on the Member Portal.',
  'register-step-3-credentials-submitting-text': 'Creating Profile..',
  'register-step-3-credentials-success-text':
    'Your profile has been created successfully.',
  'register-step-3-credentials-success-fraudulent-text':
    'Your account is under review. Please contact Customer Support at %brandPhone% for more information.',
  'register-page-help-text':
    '**Need help registering?** Please call customer service for assistance: %brandPhone%',
  'register-page-help-phone-kansas-city': '(800) 859-2144',
  'register-page-help-phone-vermont': '(866) 999-2605',
  'register-page-help-phone-horizon': '(888) 215-0025',
  'register-page-help-phone-carefirst': '(866) 758-6119',
  'register-page-help-phone-further': '(800) 859-2144',
  'App-pop-up-dismiss-button': 'Dismiss',
  'page-header-portal-title': 'Members',
  'bank-accounts_action_add-bank-account': 'Add Bank',
  'submit-claim_form-error_child-name_length':
    'Child name cannot be longer than %maxLength% characters.',
  'submit-claim_form-label_child-name': 'Child Name',
  'communications_text_please-note':
    'By opting in to text messaging, you are giving us your consent to send you automated calls and texts to service all of your accounts with us. You may opt out at any time.',
  'header_menu-item_communications': 'Communications Preferences',
  ' communications_page-title': 'Communications Preferences',
  'update-phone_form-error_alt-phone_invalid-format':
    'Please enter a valid phone number.',
  'update-phone_form-error_primary-phone_invalid-format':
    'Please enter a valid phone number.',
  'communications_form-label_phone': 'Mobile Phone Number',
  'update-phone_form-error_primary-phone_invalid-length':
    'Phone number must contain 10 digits',
  'update-phone_form-error_alt-phone_invalid-length':
    'Phone number must contain 10 digits.',
  'communications-form-editinfo-label': 'Edit Information',
  'communications-addmobilenumber-button': 'Add a Mobile Phone Number',
  'communications-descriptionsuppressed-nophonenumber':
    "We don't have a mobile number for you on file. Please add a mobile phone number.",
  'communications-form-textalert-message':
    'Text Alerts: Can we send account alerts or other non-marketing text messages to your mobile phone?',
  'communications-header-subtext':
    'Tell us how you would like to receive important account information.',
  'mobileapp-commpreferences-textalert-label': 'Text Alerts:',
  'mobileapp-commpreferences-contactinfo-nonumber':
    'No phone number added. Please add a mobile phone number.',
  'mobileapp-commpreferences-top-text':
    'Tell us how you want to receive important account information and activity alerts.',
  'mobileapp-commpreferences-page-header': 'Communication Preferences',
  'mobileapp-commpreferences-contactinfo-phonenumber-label':
    'Mobile Phone Number:',
  'mobileapp-commpreferences-textalert-signup-terms':
    'By opting in to text messaging, you are giving us your consent to send you texts to service all of your accounts with us. You may opt out at any time.',
  'mobileapp-commpreferences-contactinfo-nophone-add-button':
    'Add a Mobile Phone Number',
  'mobileapp-commpreferences-contactinfo-header': 'Your Contact Information',
  'mobileapp-commpreferences-textalert-label-info':
    'Would you like us to send account alerts or other non-marketing text messages to your mobile phone?',
  'mobileapp-commpreferences-save-button': 'Save',
  'mobileapp-commpreferences-editcontactinfo-button':
    'Edit Contact Information',
  'mobileapp-profile-commpreferences-link-subheader':
    'Manage account alerts and notifications',
  'mobileapp-profile-commpreferences-link-header': 'Communication Preferences',
  communications_form_note:
    'Note: Our new and improved mobile messaging service is coming soon!',
  'enrollment-dashboard-planstart': 'Plan Year: %startDate%',
  'enrollment-sign-in-error-enrollment-closed':
    "We're sorry, but the enrollment period for your group is closed. Please contact your employer for assistance.",
  'add-ari_page-title': 'Add authorization',
  'mobileapp-splashscreen-warning-updateBtn': 'Update',
  'mobileapp-splashscreen-warning-dismissBtn': 'Not Now',
  'mobileapp-splashscreen-warning-updaterecommended':
    'We recommend using the newest version of this app for the best experience. Would you like to update now?',
  'mobileapp-splashscreen-warning-updaterequired':
    'You must install the latest version of the Further app in order to sign in.',
  'enrollment-dashboard-single-irs-contribution':
    'If filing taxes separately (if married), contribute up to %singleIrsContribution% this year',
  'enrollment-dashboard-max-irs-contribution':
    'If filing taxes jointly (if married) or as a single parent, contribute up to %maxIrsContribution% this year',
  'enrollment-dashboard-no-debit-card-text':
    'A debit card is not included for making purchases',
  'enrollment-dashboard-debit-card-text':
    'A debit card is included for making purchases',
  'mobileapp-splashscreen-warning-limithours': '1',
  'mobileapp-splashscreen-warning-limitcount': '3',
  'enrollment-dashboard-rollover-text':
    'Your employer allows you to roll over some funds from year to year; check with your benefits administrator to learn the rollover limit',
  'enrollment-dashboard-enroll-before':
    'Enroll before: %enrollmentDeadline% Central Time',
  'enrollment-dashboard-no-rollover-text':
    'Funds cannot roll over from year to year',
  'enrollment-contact-email-label': 'Email Address',
  'enrollment-election-step-yes': 'Yes, enroll me',
  'enrollment-sign-in-error-generic':
    'An error occurred. We are unable to process information at this time. Please try again or contact Customer Service at %phoneNumber% for more information.',
  'enrollment-election-help-number-of-pay-periods':
    'This election amount will be taken in equal portions from %payPeriods% paychecks throughout the year.',
  'enrollment-text-start': 'Start',
  'enrollment-text-edit': 'Edit Enrollment',
  'enrollment-text-print': 'Print',
  'enrollment-dashboard-welcome-name': 'Welcome %firstName%!',
  'enrollment-dashboard-election-amount': 'Plan Year Election Amount: %amount%',
  'enrollment-dashboard-election-status': 'Status: %status%',
  'enrollment-election-step-election-amount-label': 'Plan Year Election Amount',
  'enrollment-election-submit': 'Submit',
  'enrollment-election-back': 'Back',
  'enrollment-election-continue': 'Continue',
  'enrollment-election-step-no': 'No',
  'enrollment-election-step-would-you-like-to-enroll':
    'Would you like to enroll in the %productName%?',
  'enrollment-election-pay-period-amount':
    'This will be %amount% per pay period.',
  'enrollment-contact-where-should-we-send-your-information':
    'Where should we send your enrollment information?',
  'enrollment-sign-in-error-can-not-find-in-system':
    'We can’t find you in our system. Please make sure you have entered your information correctly. If you continue to see this message, contact your employer’s benefits administrator for help submitting your enrollment, or call %phoneNumber%.',
  'enrollment-sign-in-see-enrollment-options': 'See Enrollment Options',
  'enrollment-application-banner-title': 'Spending Account Enrollment',
  'enrollment-sign-out-confirm-modal-text':
    'Any enrollment information you have not submitted will not be saved.',
  'enrollment-customer-service-phone-fallback': '800-859-2144',
  'enrollment-dashboard-my-enrollment': 'My Enrollment',
  'submit-claim_form-label_terms-and-conditions_submit':
    "I certify that the expenses listed above have been incurred by me and/or my eligible dependents and qualify as valid medical expenses according to my Summary Plan Description. These expenses have not been reimbursed and I will not seek reimbursement under my medical plan or any other health plan, such as an individual policy or my spouse's or dependent's health plan or a flexible spending account plan. I understand that the expense for which I am reimbursed may not be used to claim any Federal income tax deduction or credit. I also understand that I may be asked to provide further details about some expenses (e.g., a statement from a medical practitioner that the expense is to treat a specific medical condition or a more detailed certification from me).",
  'update-ari_page-description':
    'This person is authorized to contact customer service on your behalf.  You can make changes to their name and the authorization expiration date below. ',
  'cancel-card_text_refresh-data-error-message':
    "Your debit cards have been canceled, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'communication_form-label_edit-info': 'View Info',
  'submit-claim_text_possible-duplicate-claim':
    'This looks similar to another request you submitted within the last 31 days: ',
  'submit-claim_title_possible-duplicate-claim':
    'You might have already submitted this.',
  'submit-claim_action_possible-duplicate-claim-back': 'Go Back',
  'contact-us_link_chat': 'Chat now',
  'contact-us_title_chat': 'Live Chat',
  'submit-claim_action_possible-duplicate-claim-proceed': 'Proceed',
  'update-coverage-tier_page-title': 'Update health plan coverage information',
  'update-health-plan_text_confirm-close':
    'Update health plan coverage information?',
  'update-coverage-tier_page-description':
    'We use this coverage information to alert you if a manual contribution will put you over the IRS contribution limit.. This will NOT affect your coverage through your health plan; to make coverage changes, please contact your benefits administrator.',
  'update-health-plan_title_confirm-close':
    'Confirm health plan coverage information update',
  global_resources: ' Learn',
  'beneficiaries_form-label_ssn': 'Social Security Number',
  'documents_text_upload-guidelines':
    'Under 5 MB, JPEG, GIF, PDF, TIFF, PNG or BMP',
  'login_form-label_username': 'Username',
  'login_form-label_password': 'Password',
  'substantiation-alert_description':
    'You have unsubstantiated claims that require documentation',
  'account-tax-forms_body_1099-description':
    'If you made a withdrawal from your HSA during the tax year, the IRS requires you to report the withdrawals on Form 8889 when filing your tax returns. This 1099-SA will give you the information you need to complete Form 8889. Each year a new 1099 is generated for the tax year by January 31st the following year.',
  'contact-us_page-description': "We're here to help.",
  'contact-us_title_phone': 'Phone',
  'add-bank-account_page-title': 'Enter bank account information',
  'payment-methods_page-description': 'Manage your payment methods. ',
  'bank-accounts_page-description':
    'You can view and change the bank accounts tied to your profile. Connecting a personal bank account allows for direct deposit of reimbursements--the quickest and most secure way to receive your money.',
  'account_menu-item_eligibility': "What's Covered",
  'documents_page-title': 'My Records and Receipts',
  'header_menu-item_my-documents': 'My Records & Receipts',
  'debit-card_text_support-number':
    'Debit card lost or stolen? Call us and follow the prompts to cancel your card and have a new one sent. %groupTollFreePhone%',
  'update-plan-type_form-label_terms-and-conditions-non-standard':
    'I understand that I am changing from a legacy HSA plan and I will not be available to return to this plan in the future. I understand any changes to my plan type will change my current fees and interest rates. I also understand the new plan type will not be effective until the first of the following month.',
  'menu-my-accounts': 'My Accounts',
  'crossover_text_option-description_no-primary':
    'Automatic Claim Payment (Crossover) connects your health plan and medical spending accounts to allow your health plan to automatically submit claims for reimbursement. ',
  'crossover_text_option-description_has-primary':
    'Automatic Claim Payment (Crossover) connects your health plan and medical spending accounts to allow your health plan to automatically submit claims for reimbursement. Click Switch to Automatic Claim Payment button below to start the setup process.  Switching to Automatic Claim Payment will cancel your debit card.',
  'attach-documents_action_upload-singular-file': 'Upload File',
  'investment-account-transfer_page-description-veba':
    'Enter the amount you’d like to transfer to your investment account. ',
  'investment-account-transfer_page-description-hsa':
    'Enter the amount you’d like to transfer to your investment account.',
  'register_form-error_username_invalid-chars':
    'Your username may use any uppercase and lowercase letters, digits 0 through 9, and the following symbols ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \\ , > < \' ; | _ ~',
  'register_form-error_password_invalid-chars':
    'Your password may use any uppercase and lowercase letters, digits 0 through 9, and the following symbols ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \\ , > < \' ; | _ ~',
  'provider_form-error_addr-2_length':
    'Address line 2 cannot be longer than %maxLength% characters.',
  'forgot-username_page-description':
    "Enter your information below, and we'll send a message with your username to the email address in your profile.",
  'forgot-username_page-subtitle': 'Re-send Username',
  'update-plan-type_form-label_terms-and-conditions':
    'I understand any changes to my plan type will change my current fees and interest rates. I also understand the new plan type will not be effective until the first of the following month.',
  'attach-documents_action_upload-from-files': 'Attach documentation',
  'attach-documents_action_upload': 'Upload and attach documentation',
  'global_attach-documents': 'Attach Documentation',
  'cancel-all-cards_page-title': 'Cancel debit card?',
  'cancel-all-cards_page-description':
    'Canceling this debit card will immediately deactivate all other cards and permanently remove them from your account.',
  'add-debit-card_page-description':
    'Fill out the form below to start the debit card request process. ',
  'global_unprocessed-transactions': 'Unprocessed Claims',
  'submit-claim_action_provider-required-proceed-anyway': 'Get reimbursed',
  'submit-claim_text_provider-required':
    "To pay a bill, a provider must be added to your account.  If you don't have the provider's information, you can choose to be reimbursed instead.",
  'segmentation-questions_text_refresh-data-error-message':
    'We’ve recorded your answers, but we couldn’t update the information on your screen. Click your browser’s reload button to view the member portal.',
  'activate-hsa_action_go-to-portal': 'Go to Member Portal',
  'activate-hsa_text_refresh-data-error-message_navigate-to-accounts\t':
    'Click your browser’s reload button to go to the member portal.',
  'submit-app_action_over-hard-limit_cancel': 'OK',
  'add-debit-card_text_duplicate-dependent':
    'You have already requested a debit card for this dependent.',
  'add-debit-card_text_possible-duplicate-dependent':
    'You may have already requested a debit card for this dependent.  Do you want to continue with this request?',
  'documents_page-placeholder-body':
    'We’re working on improving eVault, which will be known as “My Records and Receipts”. Once the new tool is live, you’ll be able to upload receipts and match them to expenses in two easy steps. We’ve kept all of the receipts you’ve stored with us, and you’ll be able to access them when My Records and Receipts is launched. In the meantime, you can attach documentation directly to your transaction when you request a new reimbursement or pay a bill.',
  'global_validating-token': 'Validating token...',
  'add-debit-card_text_refresh-data-error-message':
    "We added the debit card to your account but we couldn't update the information on your screen.  Please click your browser's reload button.",
  'crossover_text_option-description':
    'Automatic Claim Payment (Crossover) is an electronic connection between your health plan and medical spending accounts that allow your health plan to automatically submit claims for reimbursement. Click to switch to Automatic Claim Payment. Switching to Automatic Claim Payment will cancel your debit card.',
  'crossover_text_switch-to-crossover-warning':
    'Switching to Automatic Claim Payment will cancel your debit card.',
  'manage-crossover_title_automatically-submit-these-claims':
    'Choose your Automatic Claim Payment options:',
  'crossover_action_switch-to-crossover': 'Switch to Automatic Claim Payment',
  'payment-methods_title_automatic-claim-submission': 'Automatic Claim Payment',
  'beneficiaries_text_confirm-remove-beneficiary':
    'Do you want to remove this beneficiary from your account?',
  'beneficiaries_title_confirm-remove-beneficiary': 'Remove beneficiary?',
  'beneficiaries_action_confirm-remove-beneficiary_confirm': 'Remove',
  'beneficiaries_text_confirm-remove-all-beneficiaries':
    'Do you want to remove all primary beneficiaries from your account?  Your changes will also remove all secondary beneficiaries from your account. Do you want to remove your primary beneficiaries?',
  'update-ari_text_expiration-date-notice':
    'Note: This authorization will remain in effect until the expiration date.',
  'add-ari_text_expiration-date-notice':
    'Note: This authorization will remain in effect until the expiration date.',
  'beneficiaries_form-label_terms-and-conditions_veba':
    'I understand that in the event of my death, the remaining funds in my account can first be spent down by my surviving spouse and any legal medical dependents with my spouse as the administrator of the account. If I have no surviving spouse, the remaining medical dependent(s) shall designate one dependent to administer the account. My spouse and/or any dependents can continue to be reimbursed for allowable medical expenses on a pre-tax basis, as long as they continue to meet all IRS requirements. If a surviving spouse or eligible medical dependent is no longer available, my account will be split between the stated living beneficiary(ies) to be reimbursed for allowable medical expenses on a taxable basis. I understand that if I do not name a beneficiary or the named beneficiary(ies) is no longer alive, the terms and conditions of the trust agreement may allow for the continued spend down of my account by secondary contingent beneficiaries. If allowed, my account will be split between the identified beneficiaries to be reimbursed for allowable medical expenses on a taxable basis. In the event the trust’s allowable beneficiary list is exhausted, any remaining funds will be retained by the trust and utilized as directed by the terms of the trust agreement.',
  'beneficiaries_form-label_terms-and-conditions_hsa':
    'I understand if I designate my legal spouse as my beneficiary, upon my death they will be treated as the new account holder of my Health Savings Account (HSA). I also understand if I do not designate my surviving legal spouse as my beneficiary, or my HSA passes to someone else, it ceases to be an HSA as of the date of my death, and the beneficiary may be subject to income tax on the fair market value of the HSA, reduced by any payments made for my qualified medical expenses, if paid within one year of my death. ',
  'add-debit-card_action_confirm-close_confirm': 'Cancel request',
  'submit-claim_title_provider-required': 'Provider required',
  'global_im-done': 'Done',
  'forgot_password_form-token': 'Temporary PIN',
  'update-password_page-description':
    'Enter your temporary PIN below and then use the form to change your password.',
  'update-phone_page-description':
    'Enter your temporary PIN below and then use the form to update your phone number.',
  'update-email_page-description':
    'Enter your temporary PIN below and then use the form to update your email address.',
  'update-address_page-description':
    'Enter your temporary PIN below and then use the form to update your address.',
  'update-provider_page-description':
    'Enter your temporary PIN below and then use the form to update your provider.',
  'auth-token_error':
    "We are required to send you a PIN to give you access to edit this information.  However, we don't have contact information for you on file.  Please call Customer Service at %groupTollFreePhone%.",
  'investment-transfer_form-label_terms-and-conditions':
    'I understand that by opening an investment account I am agreeing to an annual administrative fee of $18 deducted from my investment account. I also understand if my base balance should fall below $1,000 due to activity, future contributions will be used to build the base balance back up to $1,000. Investment assets will not be automatically transferred to the base balance to bring it back to $1,000 unless the Base Balance is insufficient to pay account fees. I also understand funds transferred from the basic investment account will be liquidated on a pro-rata basis according to my current asset alignments. I also understand when I request funds be transferred from the basic investment account back to the base balance, assets will be sold based on my current alignment and moved to the base balance. ',
  'register_form-label_terms-and-conditions':
    '  I have read and agree to the website privacy agreement. ',
  'global_logged-out_successful': 'You have signed out and ended your session.',
  'account-activity-eop_table-header_service-to': 'End date',
  'account-activity-eop_table-header_service-from': 'Start date',
  'update-account-hold_page-title_inactive': 'Release hold on this account?',
  'remove-ari_page-title': 'Remove authorization for this person?',
  'submit-claim_title_confirm-close': 'Cancel this request?',
  'update-account-hold_page-title_active': 'Put a hold on this account?',
  'cancel-scheduled-deposit_no': 'No',
  'activate-hsa_action_confirm-close_cancel': 'No',
  'activate-hsa_action_close-account': 'No',
  'submit-claim_action_confirm-close_cancel': 'No',
  'submit-claim_text_bank-account-required': 'A bank account is required.',
  'remove-bank-account_page-description':
    'This account will become immediately unavailable. ',
  'remove-bank-account_page-title': 'Delete this bank account?',
  'make-primary-bank-account_action_confirm': 'Make primary account',
  'make-primary-bank-account_page-description':
    'Automatic reimbursements will now be deposited into this account. ',
  'make-primary-bank-account_page-title': 'Make this your primary  account?',
  'auth-token_yes': 'Send',
  'auth-token_no': 'Cancel',
  'timed-out_sub-headline_warning':
    'You have been inactive for more then 30 minutes. For your security, we have signed you out of your session.',
  'personal-settings_action_add-ari': 'Manage',
  'submit-claim_claim-amount_pay-bill-non-hsa_page-title':
    'Enter Amount to Pay',
  'submit-claim_claim-amount_pay-bill-hsa_page-title': 'Enter Amount to Pay',
  'submit-claim_claim-amount_reimburse-non-hsa_page-title':
    'Enter Reimbursement Amount',
  'submit-claim_choose-account_reimburse_page-description':
    'Choose the account to use for this reimbursement request.',
  'submit-claim_choose-account_pay-bill_page-description':
    'Choose the account to use to pay this bill.',
  'documents_page-description':
    "All documentation you've attached to your transactions can be found here.",
  'global_logged-out_session-expired':
    'You have been inactive for more then 30 minutes. For your security, we have signed you out of your session.',
  'global_title_confirm-close': 'Do you want to cancel?',
  'global_action_confirm-close_confirm': 'Confirm',
  'add-debit-card_action_confirm-close_cancel': 'No',
  'add-dependent-debit-card_action_confirm-close_confirm': 'Cancel request',
  'add-dependent-debit-card_action_confirm-close_cancel': 'No',
  'add-dependent-debit-card_title_confirm-close': 'Cancel debit card request?',
  'add-self-debit-card_action_confirm-close_confirm': 'Cancel request',
  'add-self-debit-card_action_confirm-close_cancel': 'No',
  'add-self-debit-card_title_confirm-close': 'Cancel debit card request?',
  'add-debit-card_title_confirm-close': 'Cancel debit card request?',
  'global_action_confirm-close_cancel': 'Cancel',
  'global_text_confirm-close': 'Your changes will not be saved.',
  'activate-hsa_action_submit': 'Activate account',
  'make-deposit_text_refresh-data-error-message_update-deposit':
    "Your deposit has been updated, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'make-deposit_text_refresh-data-error-message_add-deposit':
    "Your deposit has been added, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'attach-documents_text_refresh-data-error-message':
    "The file upload is complete, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'remove-ari_text_refresh-data-error-message':
    "The authorization has been deleted, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'update-ari_text_refresh-data-error-message':
    "Your authorizations have been updated, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'add-ari_text_refresh-data-error-message':
    "This person has been authorized, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'update-coverage-tier_text_refresh-data-error-message':
    "Your coverage has been updated, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'update-plan-type_text_refresh-data-error-message':
    "Your plan has been updated, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'update-account-hold_text_refresh-data-error-message':
    "Your account has been updated, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'update-phone_text_refresh-data-error-message':
    "Your phone number has been updated, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'update-email_text_refresh-data-error-message':
    "Your email has been updated, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'update-address_text_refresh-data-error-message':
    "Your address has been updated, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'submit-claim_text_file-add-error-message':
    'We have added your request but were unable to complete your file upload(s). Click OK to see to your account activity.',
  'submit-claim_form-error_provider-tax-id_invalid-tax-id':
    'Invalid provider tax ID number',
  'submit-claim_form-error_provider-tax-id_invalid-format':
    'Provider tax ID must have 9 digits',
  'submit-claim_form-error_service-from-date_invalid':
    'Service start date must come before the service end date',
  'submit-claim_form-error_service-to-date_invalid':
    'Service end date cannot come before the service start date',
  'submit-claim_text_no-accounts':
    'You must have an account to request reimbursement for an expense.',
  'submit-claim_action_reimburse-by-check': 'Reimburse me by check',
  'submit-claim_action_confirm-close_confirm': 'Cancel request',
  'submit-claim_text_confirm-close':
    "The information you've entered will not be saved.",
  'submit-claim_text_stacking-accounts':
    "Because you have more than one medical spending account, this expense will be paid or reimbursed from your accounts in the order set by your group's plan.",
  'submit-claim_text_get-data-loading-message': 'Loading…',
  'submit-claim_text_submit-loading-message': 'Sending…',
  'submit-claim_review_page-title': 'Review',
  'submit-claim_claim-information_page-subtitle':
    'Enter information about this expense',
  'submit-claim_pay-bill_page-title': 'Pay Your Bill',
  'submit-claim_get-reimbursed_page-title': 'Get Reimbursed',
  'submit-claim_claim-amount_pay-bill-non-hsa_page-description':
    'Enter the amount of the bill you want to pay.',
  'submit-claim_claim-amount_pay-bill-hsa_page-description':
    'Enter the amount of the bill you want to pay.',
  'submit-claim_claim-amount_reimburse-non-hsa_page-description':
    'Enter the amount of your reimbursement request.',
  'submit-claim_claim-amount_reimburse-hsa_page-description':
    'Enter the amount of your reimbursement request.',
  'submit-claim_claim-amount_reimburse-hsa_page-title':
    'Enter Reimbursement Amount',
  'submit-claim_choose-account_page-title': 'Choose Account',
  'submit-claim_label_attach-documents': 'Attach Documentation',
  'submit-claim_label_enter-total': 'Enter Amount',
  'submit-claim_text_error_no-active-accounts':
    "You don't have any active accounts.",
  'remove-provider_text_refresh-data-error-message':
    "The provider has been deleted, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'add-provider_text_refresh-data-error-message':
    "The provider has been added, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'manage-crossover_text_refresh-data-error-message':
    "Your crossover selections have been updated, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'remove-bank-account_text_refresh-data-error-message':
    "Your bank account has been deleted, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'make-primary-bank-account_text_refresh-data-error-message':
    "Your bank account has been updated, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'add-bank-account_text_refresh-data-error-message':
    "Your bank account has been added, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'add-claim-note_text_refresh-data-error-message':
    "Your note has been added, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'cancel-pending-reimbursement_text_refresh-data-error-message':
    "Your reimbursement has been canceled, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'cancel-pending-claim_text_refresh-data-error-message':
    "Your claim has been canceled but we couldn't update the information on your screen. Please click your browser's reload button.",
  'cancel-pending-investment_text_refresh-data-error-message':
    "Your investment has been canceled, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'documents_page-placeholder-intro':
    "We're working to improve your experience",
  'add-dependent-debit-card_page-description':
    'Please tell us who this card is for and confirm that we have the correct information for that person.',
  'add-debit-card_text_submit-description':
    'The debit card will be mailed to the address in your profile.',
  'add-debit-card_page-title': 'Request a Debit Card',
  'debit-card_text_switch-to-debit-card-warning':
    'Switching to Debit Card will opt you out of Automatic Claim Payments.',
  'account-investment_label_account-status': 'Investment account status',
  'activate-hsa_text_refresh-data-error-message_complete':
    "Your account has been activated, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'activate-hsa_text_refresh-data-error-message_opened-account':
    "Your account has been opened, but we couldn't update the information on your screen. Please click your browser's reload button.",
  'activate-hsa_text_refresh-data-error-message_closed-account':
    "We closed your account but couldn't update the information on your screen. Please click your browser's reload button.  ",
  'activate-hsa_form-error_one-time-amount_min-value':
    'A minimum deposit amount of $5 is required to open your HSA.',
  'activate-hsa_text_over-hard-limit':
    'This amount will put you over the IRS contribution limit for the tax year.',
  'activate-hsa_action_open-account': 'Activate account',
  'activate-hsa_action_confirm-close_confirm': 'Cancel activation',
  'activate-hsa_text_confirm-close':
    "Your account hasn't been activated yet.  Do you want to cancel the activation?",
  'submit-app-error_zip_invalid-format':
    'ZIP code must have either 5 or 9 digits.',
  'submit-app_form-label_offer-code': 'Offer code?  Enter it here',
  'submit-app_text_submit_loading-message': 'Submitting your HSA application…',
  'submit-app_text_get-group-plan-types_loading-message':
    'Verifying your account information…',
  'submit-app_text_validate-contact-info_loading-message':
    'Verifying your contact information…',
  'submit-app_text_validate-hsa-applicant_loading-message':
    'Verifying your personal information…',
  'submit-app_title_review': 'Review your information',
  'submit-app_title_enter-banking-information':
    'Enter your banking information',
  'submit-app_title_enter-account-information':
    'Enter your account information',
  'submit-app_title_enter-contact-information':
    'Enter your contact information',
  'submit-app_title_enter-personal-information':
    'Enter your personal information',
  'submit-app_page-description':
    'You can open a health savings account (HSA) today, quickly and easily.  ',
  'account-activity_text_documentation-required-alert':
    'Documentation is required for this transaction.',
  'validate-email_error_unknown_form-message':
    'Confirm or edit your email address',
  'validate-email_form-label_email': 'Email address',
  'contact-us_title_address': 'Mail',
  'validate-email_error_undeliverable_email-message':
    'Sorry, we could not verify your email address.',
  'contact-us_label_toll-free': '(toll-free)',
  'contact-us_title_fax': 'Fax',
  'contact-us_title_email': 'Email',
  'contact-us_title_hours': 'Hours',
  'notifications_page-title': 'Messages',
  'validate-email_error_disposable_form-message': ' ',
  'validate-email_error_unreachable_form-message': ' ',
  'validate-email_error_illegitimate_form-message': ' ',
  'validate-email_error_default_form-message': ' ',
  'validate-email_error_undeliverable_header-text':
    'Sorry, we could not verify your email address.',
  'validate-email_error_unreachable_email-message':
    'Sorry, we could not verify your email address.',
  'validate-email_error_illegitimate_email-message':
    'Sorry, we could not verify your email address.',
  'validate-email_error_disposable_email-message':
    'Sorry, we could not verify your email address.',
  'communications_form_edit-preferences': 'Edit communication preferences',
  'communications_form_how-to-receive':
    'Indicate how you like to receive important information about your account and activity.',
  'communications_header-sub-text':
    'Choose your preferred method of communication.  ',
  'ari_label_expiration-date': 'Expiration date of authorization',
  'ari_page-description':
    'Authorize someone you trust to have access to information related to your account and call customer service on your behalf.',
  'ari_action_add-ari': 'Add new authorization',
  'remove-ari_action_confirm': 'Remove authorization',
  'update-ari_form-error_expiration-date_min-date':
    'Expiration date cannot come before the current date.',
  'update-ari_form-error_last-name_max-length':
    'Last name cannot have more than %maxLength% characters',
  'update-ari_form-error_last-name_required': 'Last name is required',
  'update-ari_form-error_first-name_max-length':
    'First name cannot have more than %maxLength% characters',
  'update-ari_form-label_expiration-date': 'Expiration date of authorization',
  'update-ari_page-title': 'Edit authorization',
  'add-ari_form-error_expiration-date_min-date':
    'Expiration date cannot come before the current date.',
  'add-ari_form-error_last-name_max-length':
    'Last name cannot have more than %maxLength% characters',
  'add-ari_form-error_last-name_required': 'Last name is required',
  'add-ari_form-error_first-name_max-length':
    'First name cannot have more than %maxLength% characters',
  'add-ari_form-label_expiration-date': 'Expiration date of authorization',
  'add-ari_page-description':
    'Authorize someone you trust to have access to information related to your account and call customer service on your behalf.',
  'providers_text_no-providers':
    'No providers found. Click Add Provider to add a provider to your profile.',
  'providers_page-description':
    'Add, edit, or delete providers from your profile.',
  'submit-app_form-label_phone-mobile': 'This is a mobile number',
  'update-phone_form-label_phone-mobile': 'This is a mobile number',
  'update-health-plan_text_loading-message': 'Saving changes...',
  'update-health-plan_form-error_health-plan_required':
    'A health plan carrier is required',
  'update-health-plan_form-label_health-plan': 'Health plan carrier',
  'update-health-plan_page-title': 'Update Health Plan',
  'validate-email_text_loading-message': 'Verifying email address…',
  'validate-email_form-error_email_required': 'Enter your email address',
  'validate-email_form-error_email_invalid-format': 'Invalid email address',
  'validate-email_error_default_header-title':
    "We couldn't verify your email address",
  'validate-email_error_default_header-text':
    'Please review your email address and confirm that it is correct.',
  'validate-email_error_undeliverable_form-message':
    'We are unable to verify your email address. ',
  'validate-email_error_illegitimate_header-title':
    "We couldn't verify your email address",
  'validate-email_error_unreachable_header-title':
    "We couldn't verify your email address",
  'validate-email_error_unreachable_header-text':
    'Please review your email address and confirm that it is correct.',
  'validate-email_error_illegitimate_header-text':
    'We are unable to verify your email address. ',
  'validate-email_error_unknown_header-title':
    "We couldn't verify your email address",
  'validate-email_error_unknown_header-text':
    'Please review your email address and confirm that it is correct.',
  'validate-email_error_disposable_header-title':
    'Potential disposable email address detected',
  'validate-email_error_disposable_header-text':
    'Please review your email address and confirm that it is correct.',
  'update-health-plan_page-description':
    'Choose the health plan you want to apply to your account',
  'update-coverage-tier_action_confirm': 'Change coverage',
  'update-account-hold_text_loading-message': 'Saving changes...',
  'account-settings_action_release-hold': 'Release hold',
  'update-account-hold_page-description_inactive':
    'This will remove the hold from your account and make it active again.',
  'update-account-hold_page-description_active':
    'This will suspend all activity for your account until you remove the hold. Any pending transactions will also be put on hold. ',
  'account-settings_action_edit-plan-coverage': 'Change coverage',
  'account-settings_action_view-beneficiaries': 'Manage',
  'account-settings_action_set-hold': 'Put on hold',
  'personal-settings_label_ari-designees': 'Authorized individuals',
  'personal-settings_label_ari-designee': 'Authorized individual',
  'personal-settings_title_release-authorization': 'Authorizations (ARI)',
  'personal-settings_text_release-authorizations':
    '%ariDesigneesQuantity% Authorized individuals',
  'beneficiaries_form-error_share-percentage_invalid-value':
    'Percentage must be a number between 1 and 100',
  'beneficiaries_type-option_secondary': 'Secondary',
  'beneficiaries_action_remove-beneficiary': 'Remove',
  'beneficiaries_form-label_share-percentage': 'Percent allocated',
  'beneficiaries_text_no-secondary-beneficiaries':
    'No secondary beneficiary has been added.',
  'beneficiaries_text_no-primary-beneficiaries_non-hsa':
    'No primary beneficiary has been added.',
  'beneficiaries_text_no-primary-beneficiaries_hsa':
    'No primary beneficiary.  Your estate has been designated as your sole beneficiary.  ',
  'beneficiaries_text_share-percentage-warning_secondary':
    'Percentage shared between secondary beneficiaries must equal 100%.',
  beneficiaries_label_amount: 'Percentage',
  'beneficiaries_text_share-percentage-warning_primary':
    'Percentage shared between primary beneficiaries must equal 100%.',
  'beneficiaries_page-description':
    'Add, edit, or remove beneficiaries from your account.',
  'beneficiaries_form-error_ssn_invalid-format':
    'Beneficiary SSN must contain 9 digits.',
  'submit-claim_form-label_terms-and-conditions_hsa':
    'I understand that I am solely responsible for any taxes or losses that are incurred with respect this claim. To my knowledge, all information provided above is complete and accurate.',
  'manage-crossover_form-label_terms-and-conditions':
    'I agree the health care expenses submitted through the Crossover feature will not be eligible for benefit payments by any other insurance carrier and that such expenses will not be manually submitted by me to this or any other reimbursement account. Once Crossover is removed, claims will no longer be accepted from your insurance carrier for reimbursement.',
  'add-bank-account_form-label_terms-and-conditions':
    'I authorize Further to deposit my claim reimbursement payments to the account indicated and I authorize the bank named to accept my claim deposit and credit the amount to my account. I confirm this information is accurate and Further is not responsible for transactions made based on incorrect banking information. \tI authorize Further to withdraw from this bank account as directed by me in order to fund my Health Savings Account. I confirm this information is accurate and Further is not responsible for transactions made based on incorrect banking information.',
  'investment-account-transfer_form-error_transfer-amount-greater-available':
    " You don't have enough funds in your account for this request.  Enter an amount that is less than or equal to the funds available in your account.",
  'investment-account-transfer_form-error_contribution-percent-greater-100':
    'You cannot contribute more than 100%.',
  'investment-transfer_form-label_future-contributions':
    'Percentage of future contributions to invest',
  'investment-transfer_form-label_transfer-amount': 'Amount to invest',
  'investment-transfer_form-label_available-transfer-balance':
    'Funds available to invest',
  'cancel-scheduled-deposit_yes': 'Cancel Deposit',
  'make-deposit_form-label_monthly-deposit-day': 'Monthly deposit date',
  'make-deposit_step_review': 'Review your deposit information',
  'make-deposit_page-title_how-much-recurring':
    'Enter the amount you’d like to deposit each month.',
  'make-deposit_page-title_how-much-one-time':
    'Enter the amount of your one-time deposit.',
  'make-deposit_action_recurring': 'Schedule a recurring deposit ',
  'make-deposit_desc_recurring':
    'A deposit that happens each month on or around the same date.',
  'account-investment_text_status-over-threshold':
    'Your balance is over $1000. You are eligible to open an investment account.',
  'account-investment_text_status-under-threshold':
    'Your balance must be over $1000 to open an investment account. ',
  'forgot-password_action_signin': 'Sign in',
  'forgot-password_step-2_page-description':
    "We've sent you an email with a temporary PIN.  Enter the PIN below and create a new password.",
  'forgot-password_step-2_page-title': 'Create new password',
  'forgot-password_page-description':
    "Enter your member portal username below.  We'll send a message with password reset instructions to the email address in your profile.",
  'forgot-password_page-subtitle': 'Reset Password',
  'forgot_username-label-select_account_id': 'Spending Account ID',
  'forgot_username-intro':
    "Enter your information below.  We'll send a message with your username to the email address in your member profile.",
  'forgot_username-subhead': 'Username Recovery',
  'register_form-error_answer_invalid-chars':
    'Answers cannot have any of the following characters: { , # -',
  'register_form-error_answer_length':
    'Answers must have between %minLength% and %maxLength% characters ',
  'register_form-error_answer_required':
    'Enter an answer for this security question',
  'register_form-error_custom-question_invalid-chars':
    'Security questions cannot have any of the following characters: { , # -',
  'register_form-error_custom-question_length':
    'Security questions must have between %minLength% and %maxLength% characters ',
  'register_form-error_password_alphanumeric':
    'Password must have at least one letter and one number',
  'register_form-error_password_first-char':
    'Password cannot begin with a symbol',
  'register_form-error_password_repeating-chars':
    'Password cannot have more than two characters that repeat',
  'register_form-error_password_length':
    'Password must have between %minLength% and %maxLength% characters ',
  'register_form-error_username_length':
    'Username must have between %minLength% and %maxLength% characters ',
  'register_form-error_zip_invalid-format': 'Enter a valid ZIP code',
  'register_form-error_zip_required': 'Enter your ZIP code',
  'register_form-error_ssn-last-4_numeric':
    'Enter the last 4 digits of your SSN',
  'register_form-error_ssn-last-4_length':
    'Enter the last 4 digits of your SSN',
  'register_form-error_selectaccount-id_required':
    'Enter your Spending Account ID (SAID)',
  'register_form-error_confirm-email_same-as': 'Email addresses do not match',
  'register_form-error_confirm-email_required': 'Re-enter your email address',
  'register_form-error_email_invalid-format': 'Invalid email address format',
  'register_form-error_email_required': 'Enter your email address',
  'register_form-error_dob_invalid-dob': 'Date of birth must be a past date',
  'register_form-error_dob_invalid-format': 'Invalid date',
  'register_validate-email_error_undeliverable_header-title':
    'We are unable to verify your email address. ',
  'register_step-2_text_loading-message': 'Completing registration…',
  'register_step-1_page-description':
    'Enter your personal information below to create your member portal account.  ',
  'register_step-1_page-subtitle': 'Enter personal information',
  'register_text_security-questions':
    'These security questions are used to verify your identity when making changes to your account.',
  'login_form-hint_password': '  ',
  login_subheadline:
    'Enter your username and password below to sign into the member portal.',
  'global_my-accounts': 'My Accounts',
  'menu-profile': 'Your Profile',
  'menu-my-account': 'My Account',
  'city-of-mpls-banner-action-text': 'Visit Portal',
  'city-of-mpls-banner-text': 'All HRA and 2025 FSA Medical and Dependent Care balances will be available on the HealthEquity EZ Receipts portal as of January 15, 2026. From this point forward, please submit all claims you want processed against your account(s) on the HealthEquity portal and use your purple HealthEquity VISA card.',
  'city-of-mpls-banner-url': 'https://participant.wageworks.com/MemberLogin'
};
